import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import IconButton from 'LuxKit/Button/IconButton'
import Counter from 'LuxKit/Counter'
import LineDraggabledotsIcon from 'LuxKit/Icons/line/LineDraggabledotsIcon'
import LineTrashAltIcon from 'LuxKit/Icons/line/LineTrashAltIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Tooltip from 'LuxKit/Tooltip'
import { rem } from 'polished'
import { useCallback } from 'react'
import styled from 'styled-components'
import type { Locations } from 'tripPlanner/pages/trip/types'
import type { DraggableAttributes } from '@dnd-kit/core'
import type { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities/useSyntheticListeners'
import { useIntl } from 'react-intl'

const StyledDateOrderTile = styled(Group)`
  background-color: ${props => props.theme.palette.neutral.default.seven};
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
  width: ${rem(600)};
  border-radius: ${props => props.theme.borderRadius.L};
  max-width: 100%;
  overflow: hidden;
`
const StyledLocationName = styled(BodyText)`
 flex: 1;
`

const DurationPicker = styled(Sheet)`
flex: 1;
`
const IconSheet = styled(Sheet)`
 display: flex; 
 align-items: center;
 cursor: grab;
 
 &:active {
   cursor: grabbing;
 }
`
const StyledCounter = styled(Counter)`
 background-color: ${props => props.theme.palette.neutral.default.seven};

`
type DragHandleProps = DraggableAttributes & {
  listeners?: SyntheticListenerMap;
  ref?: (node: HTMLElement | null) => void;
}

interface Props {
  location: Locations;
  dragHandleProps?: DragHandleProps;
  onDurationChange?: (locationIndex: number, newDuration: number) => void;
  onDelete?: (locationIndex: number) => void;
  locationIndex: number;
  disabled?: boolean;
  hasTripDates?: boolean;
}
export function AITripDateOrder(props: Props) {
  const intl = useIntl()
  const { location, dragHandleProps, onDurationChange, onDelete, locationIndex, disabled = false, hasTripDates = false } = props

  const handleCounterChange = useCallback((value: number) => {
    if (onDurationChange && !disabled && hasTripDates && value > 0) {
      onDurationChange(locationIndex, value)
    }
  }, [onDurationChange, locationIndex, disabled, hasTripDates])

  const handleDelete = useCallback(() => {
    if (onDelete && !disabled) {
      onDelete(locationIndex)
    }
  }, [onDelete, locationIndex, disabled])

  const tooltipText = intl.formatMessage({
    id: 'RHeALFcpIyxawxBxixHX',
    defaultMessage: 'Adjust Duration',
    description: 'Informational tooltip text for duration counter in the trip planner setup wizard',
  })

  return (
    <StyledDateOrderTile direction="horizontal">
      <IconSheet padding="10 6" background="neutral-six" {...dragHandleProps}>
        <LineDraggabledotsIcon />
      </IconSheet>
      <DurationPicker padding="12 24">
        <Group direction="horizontal" verticalAlign="center" gap={24}>
          <StyledLocationName variant="large">
            {location.locationName}
          </StyledLocationName>
          <Tooltip description={tooltipText}>
            <StyledCounter
              value={location.duration}
              onChange={handleCounterChange}
              disabled={disabled || !hasTripDates}
              min={1}
            />
          </Tooltip>
          <IconButton shape="circle" kind="tertiary" size="xsmall" onClick={handleDelete} disabled={disabled}>
            <LineTrashAltIcon />
          </IconButton>
        </Group>
      </DurationPicker>
    </StyledDateOrderTile>
  )
}

export default AITripDateOrder
